// 路由地址不改是为了兼容历史通知
export default [
  {
    path: '/classcard/clearplate',
    name: 'PageClearplate',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/clearplate/PageClearplate'
      ),
    meta: { modular: 42, title: '光盘行动', info: '光盘行动——首页' }
  },
  {
    path: '/classcard/clearplate/personal',
    name: 'PageClearplatePersonal',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/clearplate/PageClearplatePersonal'
      ),
    meta: { modular: 42, title: '光盘行动', info: '光盘行动-个人信息' }
  }
]
